export const companyConfigByHost = {
  default: {
    // 默认值：对齐你截图里的“统一配置”内容
    companyName: '西安创域网络科技有限公司',
    title: '西安创域网络科技有限公司',
    record_num: '陕ICP备2025076627号',
    email: 'chuangyuwangl@163.com',
    address: '陕西省西安市经济技术开发区凤城五路123号秦创原软科中心A座1302号-0240',
    intro: '',
    attr: '{"d_num":"1.9W","good_num":"574","u_num":"1.3W"}',
  },
  'yukekj.cn': {},
  'yunzhengxx.cn': {},
  'chenxixx.cn': {},
  'yyqkj.top': {},
}

export function getCompanyConfig(host) {
  // 兼容端口：localhost:8080 -> localhost
  const key = (host || '').replace(/^www\./, '').split(':')[0]
  return {
    ...companyConfigByHost.default,
    ...(companyConfigByHost[key] || {}),
  }
}

